function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// A number pair representing [start, end].

class RangeUtils {
  static isValidRange(range) {
    return range != null && range.length === 2 && Number.isInteger(range[0]) && Number.isInteger(range[1]) && range[0] <= range[1];
  }
  static validateRange(range) {
    if (!RangeUtils.isValidRange(range)) {
      throw new Error("Invalid range! ".concat(range));
    }
  }
  static isSelected(selectedRanges, index) {
    for (var i = 0; i < selectedRanges.length; i += 1) {
      var range = selectedRanges[i];
      var start = range[0];
      var end = range[1];
      if (start <= index && index <= end) {
        return true;
      }
    }
    return false;
  }
  static selectRange(selectedRanges, range) {
    var _range = _slicedToArray(range, 2),
      start = _range[0],
      end = _range[1];
    var ranges = [...selectedRanges];

    // Need to consolidate the range with previous ranges
    for (var i = ranges.length - 1; i >= 0; i -= 1) {
      var selectedRange = ranges[i];
      var selectedStart = selectedRange[0];
      var selectedEnd = selectedRange[1];
      if (selectedStart <= start && end <= selectedEnd) {
        // Already contained within a range
        return ranges;
      }
      if (start <= selectedEnd && selectedStart <= end) {
        // Overlaps the previous range, remove this range and update the new range
        start = Math.min(start, selectedStart);
        end = Math.max(end, selectedEnd);
        ranges.splice(i, 1);
      }
    }
    ranges.push([start, end]);
    return ranges;
  }
  static deselectRange(selectedRanges, range) {
    var _range2 = _slicedToArray(range, 2),
      start = _range2[0],
      end = _range2[1];
    var ranges = [...selectedRanges];
    // Need to consolidate the range with previous ranges
    for (var i = ranges.length - 1; i >= 0; i -= 1) {
      var selectedRange = ranges[i];
      var selectedStart = selectedRange[0];
      var selectedEnd = selectedRange[1];
      if (end < selectedStart || selectedEnd < start) {
        // Outside of the selected range
      } else if (selectedStart < start && end < selectedEnd) {
        // Contained within the range, split the range
        ranges[i] = [selectedStart, start - 1];
        ranges.splice(i + 1, 0, [end + 1, selectedEnd]);
        break;
      } else if (start <= selectedStart && selectedEnd <= end) {
        // Entire range should be deselected, remove from selected ranges
        ranges.splice(i, 1);
      } else if (selectedStart < start) {
        // Overlaps end of the previous range, update the end
        ranges[i] = [selectedStart, start - 1];
      } else {
        // Overlaps the start of the previous range, update the start
        ranges[i] = [end + 1, selectedEnd];
      }
    }
    return ranges;
  }

  /**
   * Count the sum total of items in the ranges provided
   *
   * @param ranges The ranges to count
   */
  static count(ranges) {
    return ranges.reduce((sum, range) => sum + (range[1] - range[0] + 1), 0);
  }

  /**
   * Get the items in the ranges provided
   * @param items List of items
   * @param ranges The ranges to include in the result
   * @returns The items in the provided ranges
   */
  static getItemsInRanges(items, ranges) {
    return ranges.reduce((acc, range) => {
      var result = [...acc];
      for (var i = range[0]; i <= range[1]; i += 1) {
        result.push(items[i]);
      }
      return result;
    }, []);
  }
}
export default RangeUtils;

/**
 * Generator that yields a range of numbers.
 * @param start Start index to generate
 * @param end End index to generate
 */
export function* generateRange(start, end) {
  // eslint-disable-next-line no-plusplus
  for (var i = start; i <= end; ++i) {
    yield i;
  }
}
//# sourceMappingURL=RangeUtils.js.map